import { ClientConfigProductName } from '@frontend/vanilla/core';

export const NextToGoLoader = {
    id: 'next-to-go',
    loaderFn: () => import(/* webpackChunkName: "ms-next-to-go" */ './next-to-go.feature'),
    product: ClientConfigProductName.SPORTS,
};
